module.exports = __webpack_public_path__ + "static/img/by_code.c8fccc24.jpg";